// | Integration of the cart with JS world.
import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEnum from "../Data.Enum/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTime from "../Data.Time/index.js";
import * as Data$dTime$dComponent from "../Data.Time.Component/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Data$dUnfoldable1 from "../Data.Unfoldable1/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dCart$dProductItem from "../Restaumatic.Cart.ProductItem/index.js";
const $DeliveryTimesStatus = tag => ({tag});
const AllAvailable = /* #__PURE__ */ $DeliveryTimesStatus("AllAvailable");
const NoneAvailable = /* #__PURE__ */ $DeliveryTimesStatus("NoneAvailable");
const SomeAvailable = /* #__PURE__ */ $DeliveryTimesStatus("SomeAvailable");
const getDeliveryTimesStatus = allDeliveryTimes => availableDeliveryTimes => {
  if (availableDeliveryTimes.length === 0) { return NoneAvailable; }
  if (allDeliveryTimes.length === availableDeliveryTimes.length) { return AllAvailable; }
  return SomeAvailable;
};
const getCurrentAvailabilities = cart => menu => {
  const productKeys = Data$dFunctor.arrayMap(Restaumatic$dCart$dProductItem.productItemKey)(cart.products);
  const catalogue = Data$dRecord.unsafeGet("catalogue")(menu);
  return Data$dFunctor.arrayMap(x => x.availability)(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap((() => {
    const $0 = Data$dRecord.unsafeGet("availabilitySchedules")(catalogue);
    return a => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(a)($0);
  })())(Data$dSemigroup.concatArray(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(x => x.availabilitySchedule)(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap((() => {
    const $0 = Data$dRecord.unsafeGet("products")(catalogue);
    return a => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(a)($0);
  })())(Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidArray)(x => x)(Data$dFunctor.arrayMap(v => {
    if (v.tag === "MenuProduct") { return Data$dFunctor.arrayMap(x => x.productId)(Data$dRecord.unsafeGet("parts")(v._1)); }
    return [];
  })(productKeys)))))))(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(x => x.availabilitySchedule)(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap((() => {
    const $0 = Data$dRecord.unsafeGet("combos")(catalogue);
    return a => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(a)($0);
  })())(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(v => {
    if (v.tag === "MenuCombo") { return Data$dMaybe.$Maybe("Just", Data$dRecord.unsafeGet("comboId")(v._1)); }
    return Data$dMaybe.Nothing;
  })(productKeys))))))))));
};
const genericDeliveryTimesStatus = {
  to: x => {
    if (x.tag === "Inl") { return AllAvailable; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return NoneAvailable; }
      if (x._1.tag === "Inr") { return SomeAvailable; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "AllAvailable") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "NoneAvailable") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "SomeAvailable") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const generateWholeLocalDayTimes = now => tz => {
  const dateLocal = Data$dTime$dLocal.utcToLocalDateTime(now)(tz)._1;
  return Data$dFunctor.arrayMap(time => Data$dTime$dLocal.$LocalDateTime(dateLocal, time))(Control$dBind.arrayBind(Data$dEnum.enumFromTo(Data$dTime$dComponent.enumHour)(Data$dUnfoldable1.unfoldable1Array)(0)(23))(hour => [
    Data$dTime.$Time(hour, 0, 0, 0),
    Data$dTime.$Time(hour, 30, 0, 0)
  ]));
};
const eqDeliveryTimesStatus = {
  eq: x => y => {
    const $0 = genericDeliveryTimesStatus.from(x);
    const $1 = genericDeliveryTimesStatus.from(y);
    if ($0.tag === "Inl") { return $1.tag === "Inl"; }
    if ($0.tag === "Inr") {
      if ($1.tag === "Inr") {
        if ($0._1.tag === "Inl") { return $1._1.tag === "Inl"; }
        if ($0._1.tag === "Inr") { return $1._1.tag === "Inr"; }
        return false;
      }
      return false;
    }
    return false;
  }
};
const calculateAvailableFulfillmentTimes = defaultTime => cart => menu => deliveryTimes => {
  const $0 = menu.timeZone;
  const availabilities = getCurrentAvailabilities(cart)(menu);
  return Data$dArray.filter(v => {
    const time = (() => {
      if (v.value.tag === "Nothing") { return defaultTime; }
      if (v.value.tag === "Just") { return v.value._1; }
      $runtime.fail();
    })();
    return Data$dFoldable.foldableArray.foldMap({mempty: true, Semigroup0: () => ({append: v$1 => v1 => v$1 && v1})})(availability => Restaumatic$dCalendar$dTypes$dAvailability.eqAvailabilityStatus.eq(Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(availability)(Data$dTime$dLocal.utcToLocalDateTime(time)($0)))(Restaumatic$dCalendar$dTypes$dAvailability.Available))(availabilities);
  })(deliveryTimes);
};
const calculateDeliveryTimesStatus = now => cart => menu => deliveryTimes => {
  const $0 = calculateAvailableFulfillmentTimes(now)(cart)(menu)(deliveryTimes);
  if ($0.length === 0) { return NoneAvailable; }
  if (deliveryTimes.length === $0.length) { return AllAvailable; }
  return SomeAvailable;
};
const calculateAvailableFulfillmentLocalTimes = cart => menu => deliveryLocalTimes => {
  const availabilities = getCurrentAvailabilities(cart)(menu);
  return Data$dArray.filter(localDateTime => Data$dFoldable.foldableArray.foldMap({mempty: true, Semigroup0: () => ({append: v => v1 => v && v1})})(availability => Restaumatic$dCalendar$dTypes$dAvailability.eqAvailabilityStatus.eq(Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(availability)(localDateTime))(Restaumatic$dCalendar$dTypes$dAvailability.Available))(availabilities))(deliveryLocalTimes);
};
const calculateAllDayDeliveryTimesStatus = now => cart => menu => {
  const deliveryTimesToday = generateWholeLocalDayTimes(now)(menu.timeZone);
  const $0 = calculateAvailableFulfillmentLocalTimes(cart)(menu)(deliveryTimesToday);
  if ($0.length === 0) { return NoneAvailable; }
  if (deliveryTimesToday.length === $0.length) { return AllAvailable; }
  return SomeAvailable;
};
export {
  $DeliveryTimesStatus,
  AllAvailable,
  NoneAvailable,
  SomeAvailable,
  calculateAllDayDeliveryTimesStatus,
  calculateAvailableFulfillmentLocalTimes,
  calculateAvailableFulfillmentTimes,
  calculateDeliveryTimesStatus,
  eqDeliveryTimesStatus,
  generateWholeLocalDayTimes,
  genericDeliveryTimesStatus,
  getCurrentAvailabilities,
  getDeliveryTimesStatus
};
